import { render, staticRenderFns } from "./EditRequesttipoPage.vue?vue&type=template&id=6ceea8b6&"
import script from "./EditRequesttipoPage.vue?vue&type=script&lang=js&"
export * from "./EditRequesttipoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports